import React from 'react'; 
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import Header from '../../../../Components/Header';
import { FooterMenu } from '../../../../Components/FooterMenu';
import { UserDetail } from '../../../../Components/Admin/Users';
import { useUser } from '../../../../Store';

export const AgentUserDetail = () => {
  const { t } = useTranslation();
  const user = useUser(useParams().userId);

  return (
    <div className='agent_layout'>
      <Header name={t('menu.memberProfile')} agentMenu={true} backToUrl={'/Agent/Users' + (user.user.closedAt ? '/Closed' : '')} />
      <UserDetail />
      <FooterMenu />
    </div>
  );
};
